import React, { Component } from "react";
import ProposalDocSection from "./proposalDocSection";
import { Redirect } from "react-router-dom";
import {
  getDocumentsTree,
  getS3File,
  getS3FileList,
  getZipFile,
} from "../../services/submissionService";
import config from "../../config";
import DropDownAction from "../common/dropDownAction";

const MASTER_CONTRACT_FILE_NAME = "Client Profile & IMA_September 2026.pdf";
const TAMP_MASTER_CONTRACT_FILE_NAME =
  "Client Profile _ IMA_TAMP_September 2026.pdf";
export const IRA_ROLLOVER_FILE_PREFIX = "IRA Rollover Recommendation Form_";
export const IRA_ROLLOVER_DISPLAY_NAME = "IRA Rollover Recommendation Form";
export const FI360_LOGIN_URL = "https://www.fi360.com/app/security/login";
export const IRA_ROLLOVER_PDF_ONLY = "pdf-only";
export const IRA_ROLLOVER_PDF_AND_FI360 = "pdf-and-fi360";
export const IRA_ROLLOVER_FI360_ONLY = "fi360-only";

const IRA_ROLLOVER_DUAL_START = Date.parse("2026-10-01T00:00:00-04:00");
const IRA_ROLLOVER_RETIREMENT = Date.parse("2027-01-01T00:00:00-05:00");

export const getIraRolloverTransitionPhase = (value = new Date()) => {
  const timestamp = value instanceof Date ? value.getTime() : new Date(value).getTime();
  if (timestamp >= IRA_ROLLOVER_RETIREMENT) return IRA_ROLLOVER_FI360_ONLY;
  if (timestamp >= IRA_ROLLOVER_DUAL_START) return IRA_ROLLOVER_PDF_AND_FI360;
  return IRA_ROLLOVER_PDF_ONLY;
};

export default class ProposalDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vicusFiles: [],
      masterContractFiles: [],
      vicusFilters: [],
      vicusMaintenanceFiles: [],
      vicusModelExpenseRatiosFiles: [],
      vicusProgramFactSheetsFiles: [],
      vicusPerformanceFiles: [],
      fidelityMaintenanceFiles: [],
      fidelityFiles: [],
      fidelityFilters: [],
      supplementalFidFilters: [],
      supplementalVicusFilters: [],
      documentTree: [],
      registrationQualification: "",
      loading: true,
      downloads: {},
      contractKey: [],
      factSheetKey: [],
      checkedItems: {},
      downloadedItems: {},
      downloadSelectedInProgress: false,
      customForms: "",
      paperworkTransitionRevision: 0,
    };
  }

  getPaperworkNow = () => {
    const configuredNow = this.props.paperworkNow;
    const value = configuredNow === undefined ? new Date() : new Date(configuredNow);
    return Number.isNaN(value.getTime()) ? new Date() : value;
  };

  getIraRolloverPhase = () =>
    getIraRolloverTransitionPhase(this.getPaperworkNow());

  isIraRolloverFile = (fileOrKey) => {
    const key =
      typeof fileOrKey === "string" ? fileOrKey : String(fileOrKey?.Key || "");
    const filename = key.split("/").pop();
    return (
      filename.startsWith(IRA_ROLLOVER_FILE_PREFIX) &&
      filename.toLowerCase().endsWith(".pdf")
    );
  };

  isFileDownloadAvailable = (fileOrKey) =>
    !this.isIraRolloverFile(fileOrKey) ||
    this.getIraRolloverPhase() !== IRA_ROLLOVER_FI360_ONLY;

  decoratePaperworkFiles = (files) =>
    (files || []).map((file) => {
      if (!this.isIraRolloverFile(file)) return file;

      const phase = this.getIraRolloverPhase();
      if (phase === IRA_ROLLOVER_PDF_ONLY) return file;

      return {
        ...file,
        paperworkDisplayName:
          phase === IRA_ROLLOVER_FI360_ONLY
            ? IRA_ROLLOVER_DISPLAY_NAME
            : this.getFileName(file),
        paperworkDownloadDisabled: phase === IRA_ROLLOVER_FI360_ONLY,
        paperworkExternalAction: {
          href: FI360_LOGIN_URL,
          label: "Open Fi360",
          title: "Open Fi360 in a new tab",
        },
      };
    });

  getAvailableSelectedFiles = () =>
    Object.values(this.state.checkedItems).filter((key) =>
      this.isFileDownloadAvailable(key)
    );

  schedulePaperworkTransitionRefresh = () => {
    if (this.props.paperworkNow !== undefined || !this._isMounted) return;
    if (this.paperworkTransitionTimer) clearTimeout(this.paperworkTransitionTimer);

    const now = this.getPaperworkNow().getTime();
    const nextTransition = [
      IRA_ROLLOVER_DUAL_START,
      IRA_ROLLOVER_RETIREMENT,
    ].find((timestamp) => timestamp > now);
    if (!nextTransition) return;

    const delay = Math.min(nextTransition - now + 1000, 2147483647);
    this.paperworkTransitionTimer = setTimeout(() => {
      if (this._isMounted) {
        this.setState(
          (previousState) => ({
            paperworkTransitionRevision:
              previousState.paperworkTransitionRevision + 1,
          }),
          this.schedulePaperworkTransitionRefresh
        );
      }
    }, delay);
  };

  download(filename, text, contextType = "text/plain") {
    var element = document.createElement("a");
    element.setAttribute("href", `data:${contextType};base64,` + text);
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);

    if (this._isMounted)
      this.setState((prevState) => {
        return {
          downloadedItems: {
            ...prevState.downloadedItems,
            [filename]:
              prevState.downloadedItems[filename] >= 1
                ? prevState.downloadedItems[filename] + 1
                : 1,
          },
        };
      });
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  handleDownload = async (
    prefixfilename,
    filename,
    callBackProgress,
    bucket = config.FORMS_BUCKET
  ) => {
    if (!this.isFileDownloadAvailable(prefixfilename)) return;

    let text = "";
    let promises = [];
    let results = [];
    async function handlePromise(promises) {
      results = await Promise.all(promises);
    }
    // Generate download
    let result = await getS3File(bucket, prefixfilename);
    let completedPromises = 1;
    const totalPromises = result.chunks;
    callBackProgress(
      Math.round((completedPromises / parseInt(result.chunks)) * 100)
    );
    text = result.data;
    if (parseInt(result.chunks) > 1) {
      for (let index = 1; index < parseInt(result.chunks); index++) {
        promises.push(getS3File(bucket, prefixfilename, index));
      }
      handlePromise(promises);
    }
    do {
      await this.sleep(500);
      for (let index = 0; index < results.length; index++) {
        if (results[index].requestedSection === String(completedPromises)) {
          text = text + results[index].data;
          completedPromises = completedPromises + 1;
        }
      }
      callBackProgress(
        Math.round((completedPromises / parseInt(result.chunks)) * 100)
      );
    } while (String(completedPromises) !== totalPromises);
    if (this._isMounted) this.download(filename, text, result.contentType);
    text = "";
    promises = [];
    results = [];
  };

  handleToggleFile = (file, e) => {
    if (!this.isFileDownloadAvailable(file)) return;

    const id = `${file.Key.split("/")[file.Key.split("/").length - 1]}`;
    const checked = e.target.checked;
    if (checked === false) {
      let selectedItems = { ...this.state.checkedItems };
      delete selectedItems[id];
      this.setState({ checkedItems: selectedItems });
    } else {
      this.setState((previousState) => {
        return {
          checkedItems: {
            ...previousState.checkedItems,
            [id]: file.Key,
          },
        };
      });
    }
  };

  handleDownloadSelectedInProgress = (booleanValue) => {
    this.setState({ downloadSelectedInProgress: booleanValue });
  };

  handleDownloadSelected = async () => {
    const selectedFiles = this.getAvailableSelectedFiles();
    if (selectedFiles.length === 0) return;

    this.handleDownloadSelectedInProgress(true);
    let response = await getZipFile(
      this.props.user,
      new Date().toUTCString(),
      selectedFiles
    );
    
    // Parse the response - it comes back as {statusCode: 200, body: "filename.zip"}
    let filename;
    if (response?.body) {
      // The body contains the filename as a string, not JSON
      filename = response.body;
    } else if (typeof response === 'string') {
      filename = response;
    } else {
      filename = response;
    }
    
    await this.handleDownload(
      filename,
      filename,
      () => null,
      "vicus-one-day-expire"
    );
    Object.entries(this.state.checkedItems).forEach(([element, key]) => {
      if (!selectedFiles.includes(key)) return;
      if (this._isMounted)
        this.setState((previousState) => {
          return {
            downloadedItems: {
              ...previousState.downloadedItems,
              [element]: previousState.downloadedItems[element]
                ? previousState.downloadedItems[element] + 1
                : 1,
            },
          };
        });
    });
    this.handleDownloadSelectedInProgress(false);
  };

  downloadURL(Url, filename) {
    const url = Url;
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  getFileName = (file) => {
    if (!file || !file.Key) return "";
    const keyParts = file.Key.split("/");
    return keyParts[keyParts.length - 1];
  };

  normalizePaperworkName = (value, customForms = "") => {
    let output = String(value || "");
    if (customForms) output = output.replaceAll(customForms, "");
    return output.trim().toLowerCase();
  };

  isTampCustomForms = (customForms) =>
    String(customForms || "").trim().toUpperCase() === "TAMP";

  getMasterContractFileName = (customForms) =>
    this.isTampCustomForms(customForms)
      ? TAMP_MASTER_CONTRACT_FILE_NAME
      : MASTER_CONTRACT_FILE_NAME;

  getProposalRegistrationValues = (proposal) => {
    const parseRegistrations = (value) => {
      if (Array.isArray(value)) return value;
      if (value && typeof value === "object") return [value];
      if (typeof value !== "string" || value.trim() === "") return [];

      try {
        const parsed = JSON.parse(value.replace(/'/g, '"'));
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (_error) {
        return [value];
      }
    };

    const preferred = parseRegistrations(proposal?.registrations);
    const registrations =
      preferred.length > 0
        ? preferred
        : parseRegistrations(proposal?.REGISTRATION);

    return Array.from(
      new Set(
        registrations
          .map((registration) =>
            typeof registration === "string"
              ? registration
              : registration?.value
          )
          .map((registration) => String(registration || "").trim())
          .filter(Boolean)
      )
    );
  };

  isFeeDisclosureFile = (file) => {
    const key = String(file?.Key || "").toLowerCase();
    return (
      key.includes("program fee appendices") ||
      key.includes("fee appendix")
    );
  };

  getVicusPrimaryFiles = ({
    masterContractFiles,
    vicusFiles,
    vicusFilters,
    contractKey,
    customForms,
  }) => {
    const useTampContract = this.isTampCustomForms(customForms);
    const masterContractFileName = this.getMasterContractFileName(customForms);
    const normalizedKeys = (contractKey || []).map((key) =>
      this.normalizePaperworkName(key, customForms)
    );
    const getMatchingStrategyKey = (file) => {
      const fileName = this.normalizePaperworkName(
        this.getFileName(file),
        customForms
      );
      return normalizedKeys.find((key) => fileName.startsWith(key));
    };
    const isRetiredStrategyDocument = (file) => {
      const matchingKey = getMatchingStrategyKey(file);
      const fileName = this.normalizePaperworkName(
        this.getFileName(file),
        customForms
      );
      return (
        Boolean(matchingKey) &&
        (matchingKey.includes("fee appendix") ||
          matchingKey.includes("contract") ||
          fileName.includes("contract") ||
          fileName.includes("fee appendix"))
      );
    };
    const isEligibleFile = (file) =>
      Boolean(file?.Key) &&
      !file.Key.includes("Proposal Request") &&
      !file.Key.toLowerCase().includes("rfp") &&
      !this.isFeeDisclosureFile(file);
    const compareBaseNames = (file1, file2) => {
      const getBaseName = (file) =>
        this.getFileName(file)
          .split(".")[0]
          .split("_")
          .slice(0, -1)
          .join("_")
          .replaceAll(customForms || "", "")
          .trim();
      return getBaseName(file1).localeCompare(getBaseName(file2));
    };

    const primaryContracts = (
      (useTampContract ? vicusFiles : masterContractFiles) || []
    ).filter(
      (file) => this.getFileName(file) === masterContractFileName
    );
    const strategyDocuments = (vicusFiles || [])
      .filter(isEligibleFile)
      .filter((file) => {
        const matchingKey = getMatchingStrategyKey(file);
        return Boolean(matchingKey) && !isRetiredStrategyDocument(file);
      })
      .sort(compareBaseNames);
    const registrationDocuments = (vicusFiles || [])
      .filter(isEligibleFile)
      .filter((file) => !isRetiredStrategyDocument(file))
      .filter((file) => {
        const filePrefix = this.getFileName(file)
          .split(".")[0]
          .split("_")[0]
          .replaceAll(customForms || "", "")
          .trim();
        return (vicusFilters || []).some((filter) =>
          String(filter).includes(filePrefix)
        );
      });

    const seenKeys = new Set();
    return [
      ...primaryContracts,
      ...strategyDocuments,
      ...registrationDocuments,
    ].filter(
      (file) => {
        if (!file?.Key || seenKeys.has(file.Key)) return false;
        seenKeys.add(file.Key);
        return true;
      }
    );
  };

  handleCreateIsp = () => {
    const proposal = this.props.location?.state?.proposal;
    if (this.props.onCreateISPFromProposal && proposal) {
      this.props.onCreateISPFromProposal(proposal);
      return;
    }
    if (this.props.clearProposalState) this.props.clearProposalState();
    this.props.history.push("/plan/step-guide");
  };

  getPaperworkProposalType = (proposal) => {
    const proposalTypes = Array.isArray(this.props.proposalTypes)
      ? this.props.proposalTypes
      : [];
    const program = String(proposal?.program || "").trim();
    const programActual = String(proposal?.ProgramActual || "").trim();

    return (
      (program &&
        proposalTypes.find((proposalType) => proposalType.name === program)) ||
      (programActual &&
        proposalTypes.find(
          (proposalType) => proposalType.powerPoint === programActual
        ))
    );
  };

  getFiles = async () => {
    const { proposal } = this.props.location.state;
    let advisorCustomForms = "";
    if (this.props.userInfo.Advisors) {
      for (const iterator of Object.keys(this.props.userInfo.Advisors)) {
        if (
          this.props.userInfo.Advisors[iterator].Name ===
          proposal["ADVISOR NAME"]
        ) {
          advisorCustomForms =
            this.props.userInfo.Advisors[iterator].CustomForms.trim();
          this.setState({
            customForms: advisorCustomForms,
          });
          break;
        }
      }
    }
    let documentTreeResult = await getDocumentsTree();
    let documentTree;
    try {
      if (documentTreeResult?.body) {
        documentTree = JSON.parse(documentTreeResult.body);
      } else if (Array.isArray(documentTreeResult)) {
        documentTree = documentTreeResult;
      } else {
        documentTree = documentTreeResult;
      }
    } catch (e) {
      console.error("Error parsing document tree:", e);
      documentTree = [];
    }
    // Get Account Opening files
    let mainfolder = "public"; // public || test
    let vicusFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/Vicus Capital Forms${
        advisorCustomForms ? ` - ${advisorCustomForms}` : ""
      }/`
    );
    let masterContractFiles = advisorCustomForms
      ? await getS3FileList(
          config.FORMS_BUCKET,
          `${mainfolder}/Account Opening/Vicus Capital Forms/`
        )
      : vicusFiles;
    let fidelityFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/Fidelity Forms/`
    );
    let supplementalFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/SMA Forms/`
    );
    // Get Account Maintenance files - Vicus
    let vicusMaintenanceFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Maintenance/Vicus Capital Forms${
        advisorCustomForms ? ` - ${advisorCustomForms}` : ""
      }/`
    );
    // Get Account Maintenance files - Fidelity
    let fidelityMaintenanceFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Maintenance/Fidelity Forms/`
    );

    // Get Model Expense Ratios files
    let vicusModelExpenseRatiosFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Model Expense Ratios/`
    );
    // Get account maintenance files
    let vicusProgramFactSheetsFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Program Fact Sheets/`
    );
    // Get account Performance
    let vicusPerformanceFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Performance/`
    );
    if (this._isMounted) {
      if (vicusFiles.data === undefined) vicusFiles.data = [];
      this.setState({ vicusFiles: vicusFiles.data });
      if (masterContractFiles.data === undefined) masterContractFiles.data = [];
      this.setState({ masterContractFiles: masterContractFiles.data });
      if (supplementalFiles.data === undefined) supplementalFiles.data = [];
      this.setState({ supplementalFiles: supplementalFiles.data });
      if (fidelityFiles.data === undefined) fidelityFiles.data = [];
      this.setState({ fidelityFiles: fidelityFiles.data });
      if (supplementalFiles.data === undefined) supplementalFiles.data = [];
      this.setState({ supplementalFiles: fidelityFiles.data });
      this.setState({ documentTree: documentTree });
      if (vicusMaintenanceFiles.data === undefined)
        vicusMaintenanceFiles.data = [];
      this.setState({ vicusMaintenanceFiles: vicusMaintenanceFiles.data });
      if (fidelityMaintenanceFiles.data === undefined)
        fidelityMaintenanceFiles.data = [];
      this.setState({
        fidelityMaintenanceFiles: fidelityMaintenanceFiles.data,
      });
      if (vicusModelExpenseRatiosFiles.data === undefined)
        vicusModelExpenseRatiosFiles.data = [];
      this.setState({
        vicusModelExpenseRatiosFiles: vicusModelExpenseRatiosFiles.data,
      });
      if (vicusProgramFactSheetsFiles.data === undefined)
        vicusProgramFactSheetsFiles.data = [];
      this.setState({
        vicusProgramFactSheetsFiles: vicusProgramFactSheetsFiles.data,
      });
      if (vicusPerformanceFiles.data === undefined)
        vicusPerformanceFiles.data = [];
      this.setState({
        vicusPerformanceFiles: vicusPerformanceFiles.data,
      });
    }
    const registrationValues = this.getProposalRegistrationValues(proposal);
    const accountTypes = new Set(
      this.props.registrationTypes
        .filter((registrationType) =>
          registrationValues.includes(registrationType.name)
        )
        .map((registrationType) => registrationType["Account Type"])
        .filter(Boolean)
    );
    const qualifications = [];
    const vicusFilterSet = new Set();
    const fidelityFilterSet = new Set();
    let supplementalVicusFilters = [];
    let supplementalFidFilters = [];

    (documentTree || []).forEach((doc) => {
      const documentName = String(doc?.Name || "");
      if (documentName.toLowerCase() === "supplemental") {
        supplementalVicusFilters = doc["Vicus Forms"] || [];
        supplementalFidFilters = doc["Fidelity Forms"] || [];
        return;
      }

      const qualification = documentName.split(" ")[0];
      if (!accountTypes.has(qualification)) return;

      if (!qualifications.includes(qualification)) {
        qualifications.push(qualification);
      }
      (doc["Vicus Forms"] || []).forEach((filter) =>
        vicusFilterSet.add(filter)
      );
      (doc["Fidelity Forms"] || []).forEach((filter) =>
        fidelityFilterSet.add(filter)
      );
    });

    if (this._isMounted) {
      this.setState({
        registrationQualification: qualifications.join(" / "),
        vicusFilters: Array.from(vicusFilterSet),
        fidelityFilters: Array.from(fidelityFilterSet),
        supplementalVicusFilters,
        supplementalFidFilters,
        loading: false,
      });
    }
  };

  componentDidMount = () => {
    this._isMounted = true;
    this.schedulePaperworkTransitionRefresh();
    if (this.props.location.state !== undefined) this.getFiles();
    if (this._isMounted && this.props.location.state !== undefined) {
      const { proposal } = this.props.location.state;
      const proposalType = this.getPaperworkProposalType(proposal);
      if (proposalType) {
        const paperwork = proposalType.paperwork || {};
        this.setState({
          contractKey: Array.isArray(paperwork.contract)
            ? paperwork.contract
            : [],
          factSheetKey: Array.isArray(paperwork.factSheet)
            ? paperwork.factSheet
            : [],
        });
      }
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    if (this.paperworkTransitionTimer) clearTimeout(this.paperworkTransitionTimer);
  };

  render() {
    if (this.props.location.state === undefined)
      return <Redirect to="/proposals" />;

    const { proposal } = this.props.location.state;
    const paperworkProposal = {
      ...proposal,
      registrations: JSON.stringify(
        this.getProposalRegistrationValues(proposal)
      ),
    };
    let {
      vicusFiles,
      masterContractFiles,
      vicusFilters,
      fidelityFiles,
      fidelityMaintenanceFiles,
      fidelityFilters,
      supplementalVicusFilters,
      supplementalFidFilters,
      vicusMaintenanceFiles,
      vicusModelExpenseRatiosFiles,
      vicusProgramFactSheetsFiles,
      vicusPerformanceFiles,
      registrationQualification,
      contractKey,
      factSheetKey,
      checkedItems,
      downloadedItems,
      downloadSelectedInProgress,
      customForms,
    } = this.state;
    const vicusPrimaryFiles = this.getVicusPrimaryFiles({
      masterContractFiles,
      vicusFiles,
      vicusFilters,
      contractKey,
      customForms,
    });
    const primaryContractReady = vicusPrimaryFiles.some(
      (file) =>
        this.getFileName(file) ===
        this.getMasterContractFileName(customForms)
    );
    const availableSelectedFiles = this.getAvailableSelectedFiles();

    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 50px)",
            position: "fixed",
            width: "100vw",
            backgroundColor: "#A2AAB6",
            pointerEvents: "none",
          }}
        />

        <div className="container" style={{ paddingTop: "20px" }}>
          <div
            className="card"
            style={{ width: "100%", margin: "15px 0", borderWidth: "1px" }}
          >
            <div className="row col-12" style={{ padding: "0", margin: "0" }}>
              <h5
                style={{ padding: "10px 20px 0", fontSize: "35px", color: "#385EA4" }}
                className="col-lg-6"
              >
                Paperwork:
              </h5>
              <h5
                style={{
                  padding: "10px 20px 0",
                  fontSize: "35px",
                  textAlign: "right",
                }}
                className="col-md-6"
              >
                <DropDownAction
                  customStyle={{
                    backgroundColor:
                      availableSelectedFiles.length > 0
                        ? "#5cb85c"
                        : "#385EA4",
                    color: "white",
                    outline: "none",
                    border: "none",
                    height: "38px",
                  }}
                  style={{
                    outline: "none",
                    border: "none",
                    margin: "none",
                    display: "inline-flex",
                    marginRight: "5px",
                    minWidth: "92px",
                    padding: "0",
                  }}
                  ulStyle={{
                    padding: "0",
                    minWidth: "92px",
                    height: "38px",
                  }}
                  drop="dropleft"
                  title={
                    <div style={{ paddingBottom: "2px" }}>
                      {this.state.downloadSelectedInProgress === true ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : null}
                      <span
                        style={{
                          fontSize: "10px",
                          fontFamily: "none",
                        }}
                      >
                        &#9664;
                      </span>{" "}
                      Actions
                    </div>
                  }
                  items={[
                    <button
                      title="Download Selected"
                      disabled={
                        availableSelectedFiles.length < 1 ||
                        downloadSelectedInProgress
                      }
                      style={{
                        width: "92px",
                        height: "100%",
                        backgroundColor: "#385EA4",
                        color: "white",
                        borderColor: "white",
                      }}
                      onClick={async () => {
                        this.handleDownloadSelected();
                      }}
                      className="col btn btn-sm"
                    >
                      <span style={{ fontSize: "15px" }}>Download</span>
                    </button>,
                  ]}
                />
              </h5>
            </div>
            <ProposalDocSection
              downloadedItems={downloadedItems}
              checkedItems={checkedItems}
              handleToggleFile={this.handleToggleFile}
              downloadAllInProgress={this.downloadAllInProgress}
              title="Vicus Capital Paperwork:"
              values={paperworkProposal}
              qualification={registrationQualification}
              files={this.decoratePaperworkFiles(vicusPrimaryFiles)}
              primaryAction={
                !this.state.loading && primaryContractReady
                  ? {
                      label: "Investment Strategy Plan and Fee Disclosure",
                      buttonLabel: "Create ISP",
                      title: "Open the ISP Generator",
                      onClick: this.handleCreateIsp,
                    }
                  : null
              }
              supplementalFiles={this.decoratePaperworkFiles(vicusProgramFactSheetsFiles
                .filter((file) => {
                  for (let i = 0; i < factSheetKey.length; i++) {
                    if (
                      file.Key &&
                      file.Key.toString()
                        .split("/")
                        [file.Key.toString().split("/").length - 1].split(
                          "_"
                        )[0]
                        .replaceAll(customForms, "")
                        .trim()
                        .toLowerCase() ===
                        factSheetKey[i]
                          .toString()
                          .replaceAll(customForms, "")
                          .trim()
                          .toLowerCase()
                    ) {
                      return true;
                    }
                  }
                  return false;
                })
                .concat(
                  [
                    ...new Set([
                      ...vicusFiles,
                      ...vicusMaintenanceFiles,
                      ...vicusModelExpenseRatiosFiles,
                      ...vicusPerformanceFiles,
                    ]),
                  ]
                    .filter((v, i, a) => {
                      return (
                        a.findIndex(
                          (t) => {
                            // Get filename without path and extension
                            const tFileName = t.Key.split("/")[t.Key.split("/").length - 1].split(".")[0];
                            const vFileName = v.Key.split("/")[v.Key.split("/").length - 1].split(".")[0];

                            // Get base name (all parts except the last, which is typically the date)
                            const tBaseName = tFileName.split("_").slice(0, -1).join("_")
                              .replaceAll(customForms, "")
                              .trim();
                            const vBaseName = vFileName.split("_").slice(0, -1).join("_")
                              .replaceAll(customForms, "")
                              .trim();

                            return tBaseName === vBaseName;
                          }
                        ) === i
                      );
                    })
                    .filter((file) => {
                      return !file.Key.includes("Proposal Request");
                    })
                    .filter((file) => {
                      for (
                        let index = 0;
                        index < supplementalVicusFilters.length;
                        index++
                      ) {
                        const element = supplementalVicusFilters[index];
                        if (
                          element ===
                          file.Key.split("/")
                            [file.Key.split("/").length - 1].split("_")[0]
                            .replaceAll(customForms, "")
                            .trim()
                        ) {
                          return true;
                        }
                      }
                      return false;
                    })
                    .filter((file) => {
                      for (
                        let index = 0;
                        index < supplementalVicusFilters.length;
                        index++
                      ) {
                        const element = supplementalVicusFilters[index];
                        if (
                          element ===
                          file.Key.split("/")
                            [file.Key.split("/").length - 1].split("_")[0]
                            .replaceAll(customForms, "")
                            .trim()
                        ) {
                          return true;
                        }
                      }
                      return false;
                    })
                    .sort((file1, file2) => {
                      // Get full filename without extension, keeping all parts except the date (last part)
                      const file1Parts = file1.Key.split("/")[file1.Key.split("/").length - 1].split(".")[0].split("_");
                      const file2Parts = file2.Key.split("/")[file2.Key.split("/").length - 1].split(".")[0].split("_");

                      const file1Name = file1Parts.slice(0, -1).join("_")
                        .replaceAll(customForms, "")
                        .trim();
                      const file2Name = file2Parts.slice(0, -1).join("_")
                        .replaceAll(customForms, "")
                        .trim();

                      if (file1Name < file2Name) {
                        return -1;
                      }
                      if (file1Name > file2Name) {
                        return 1;
                      }
                      return 0;
                    })
                ))}
              handleDownload={this.handleDownload}
              downloadURL={this.downloadURL}
              canDownloadFile={this.isFileDownloadAvailable}
              loading={this.state.loading}
            />
            <ProposalDocSection
              downloadedItems={downloadedItems}
              checkedItems={checkedItems}
              handleToggleFile={this.handleToggleFile}
              downloadAllInProgress={this.downloadAllInProgress}
              title="Fidelity Paperwork:"
              values={paperworkProposal}
              qualification={registrationQualification}
              files={this.decoratePaperworkFiles(fidelityFiles
                .filter((file) => {
                  return !file.Key.includes("Proposal Request");
                })
                .sort()
                .filter((file) => {
                  for (let index = 0; index < fidelityFilters.length; index++) {
                    const element = fidelityFilters[index];
                    if (
                      element.includes(
                        file.Key.split("/")
                          [file.Key.split("/").length - 1].split(".")[0]
                          .split("_")[0]
                          .replaceAll(customForms, "")
                          .trim()
                      )
                    ) {
                      return true;
                    }
                  }
                  return false;
                }))}
              supplementalFiles={this.decoratePaperworkFiles([
                ...new Set(
                  fidelityMaintenanceFiles
                    ? [...fidelityMaintenanceFiles, ...fidelityFiles]
                    : [...fidelityFiles]
                ),
              ]
                .filter((file) => {
                  return !file.Key.includes("Proposal Request");
                })
                .filter((file) => {
                  for (
                    let index = 0;
                    index < supplementalFidFilters.length;
                    index++
                  ) {
                    const element = supplementalFidFilters[index];
                    if (
                      element.includes(
                        file.Key.split("/")
                          [file.Key.split("/").length - 1].split(".")[0]
                          .split("_")[0]
                          .replaceAll(customForms, "")
                          .trim()
                      )
                    ) {
                      return true;
                    }
                  }
                  return false;
                }))}
              handleDownload={this.handleDownload}
              downloadURL={this.downloadURL}
              canDownloadFile={this.isFileDownloadAvailable}
              loading={this.state.loading}
            />
          </div>
        </div>
      </div>
    );
  }
}
